<mat-card-content class="flex flex-row entry-table h-full">
  <ag-grid-angular
    style="max-width: 2256px; width: 100%;"
    class="ag-theme-balham w-full"
    [rowData]="filteredEntries"
    [columnDefs]="columnDefs"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [gridOptions]="gridOptions"
    [rowSelection]="'multiple'"
    [suppressRowClickSelection]="true"
    [animateRows]="true"
    [getRowId]="getRowId"
    (gridReady)="onGridReady($event)"
    (rowSelected)="onRowSelection()"
    (cellDoubleClicked)="onCellDoubleClicked($event)">
  </ag-grid-angular>
</mat-card-content>
